import React, { Component } from 'react';

import './base.css';


import OWSite from './ow-generic-site'

import MazeApp from '../components/MazeApp';

class Base extends Component {

  constructor(props)
  {
    super(props);

  }

  componentDidMount()
  { 
  }

 
  render() {
    return (
      <div id="base_template base_template_clearfix">

        <OWSite>
          <div id='owsite-child'>

            <MazeApp />

          </div>
        </OWSite>

      </div>
    );
  }
}

export default Base;
